import MuteIcon from './MuteIcon';

export default MuteIcon;
